import { Box, Button, Heading, TextInput } from 'grommet';
import React, { Component } from 'react'; 
import './index.css';
import 'animate.css';

export interface ILoginProps {
	//Here we pass the Props Interface
	setUserLoggedIn : Function
}

export interface ILoginState {
	//here we pass the State Interface
	username : string,
	password : string,
}

//class ComponentName Component<PropsInterface, StateInterface>
class Login extends Component<ILoginProps, ILoginState> {
	
	constructor(props:ILoginProps){
		super(props)

		this.validateLogin = this.validateLogin.bind(this)

		this.state = {
			username : "",
			password : "",
		}
	}
	 

	setUsernameValue(  input : any ){
		this.setState({username : input })
	}

	setPasswordValue(  input : any ){
		this.setState({password : input })
	}
 
 

	// After the component did mount, we set the state.
	componentDidMount() {
	}

	validateLogin() {
		// alert('Function not implemented: ' + this.state.username +"," + this.state.password);
		this.props.setUserLoggedIn(true,this.state.username)
	}
	

	render() {
		return (
			<Box
			 className='animate__animated animate__fadeIn'
  direction="column"
   
  height={"calc(100vh - 100px) "}
  justify='center'
  align='center'
  
  alignContent='center'
  pad="large"
>
	<img src="/assets/LOGO.png" alt='NET14 P.C.' />
<Heading size='26px' margin="20px" textAlign='center'>Net14 : MobileEnergy</Heading>

<TextInput
	  style={{marginBottom : "20px" }}
      placeholder="Χρήστης"
	  textAlign='center'
	  
      value={this.state.username}
      onChange={event => this.setUsernameValue(event.target.value)}
    />
   <TextInput
   	  style={{marginBottom : "20px" ,  }}
      placeholder="Κωδικός"
	  textAlign='center'
      value={this.state.password}
	  type={"password"}
      onChange={event => this.setPasswordValue(event.target.value)}
    />

<Button   color={"dark"}  fill="horizontal"  label="Σύνδεση" onClick={()=>{this.validateLogin()}} />
</Box>
		);
	}
}

export default Login;

 